import { getUserDetails } from "./authUtils";
import { formEntites } from "./constants";

export const statusParameters = {
  none: {
    includeOverdue: true,
    statusCode: "-1",
  },
  all: {
    includeOverdue: true,
    statusCode: "-1",
  },
  cancelled: {
    includeOverdue: false,
    statusCode: "2",
  },
  completed: {
    includeOverdue: false,
    statusCode: "1",
  },
  pending: {
    includeOverdue: false,
    statusCode: "0",
  },
  "pending_and_overdue": {
    includeOverdue: true,
    statusCode: "0",
  },
  overdue: {
    includeOnlyOverdue: true,
    statusCode: "0",
  },
};

export const taskStatusMap = {
  1: "completed",
  0: "pending",
};

export const constructPayload = (widget = {}) => {
  const { config = {} } = widget;
  const { taskStatus, taskTypes, objectType } = config;
  const user = getUserDetails();
  let userID = "";
  if (user) {
    userID = user.Id;
  }
  let filters = {
    lookupName: "OwnerId",
    lookupValue: userID,
    leadType: objectType?.InternalName || null
  };

  if (taskStatus && taskStatus.id) {
    const statusParams = statusParameters[taskStatus.id];
    if (statusParams) {
      filters = { ...filters, ...statusParams };
    }
  }

  if (taskTypes) {
    if (Array.isArray(taskTypes.category) && taskTypes.category.length > 0) {
      filters.taskTypeId = taskTypes.category[0];
    } else {
      filters.taskTypeId = [
        ...taskTypes.appointmentId,
        ...taskTypes.todoId,
      ].join(",");
    }
  }

  return {
    pageIndex: 0,
    pageSize: 100,
    sortField: "DueDate",
    sortDirection: 0,
    includeCsv: null,
    excludeCsv: null,
    filters,
  };
};

export const getDateRange = (dateFilterId) => {
  const today = new Date();
  let from, to;

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  switch (dateFilterId) {
    case "today":
      to = formatDate(today);
      from = to;
      return { from, to };
    case "yesterday": {
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      to = formatDate(yesterday);
      from = to;
      return { from, to };
    }
    case "tomorrow": {
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      to = formatDate(tomorrow);
      from = to;
      return { from, to };
    }
    case "last_7_days": {
      to = formatDate(today);
      from = new Date(today);
      from.setDate(today.getDate() - 6);
      from = formatDate(from);
      break;
    }
    case "next_7_days": {
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      from = formatDate(tomorrow);
      const next7Days = new Date(today);
      next7Days.setDate(today.getDate() + 7);
      to = formatDate(next7Days);
      break;
    }
    case "last_30_days": {
      to = formatDate(today);
      from = new Date(today);
      from.setDate(today.getDate() - 29);
      from = formatDate(from);
      break;
    }
    case "last_month": {
      const lastMonthStart = new Date(
        today.getFullYear(),
        today.getMonth() - 1,
        1
      );
      const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);
      from = formatDate(lastMonthStart);
      to = formatDate(lastMonthEnd);
      break;
    }
    case "next_month": {
      const nextMonthStart = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        1
      );
      const nextMonthEnd = new Date(
        today.getFullYear(),
        today.getMonth() + 2,
        0
      );
      from = formatDate(nextMonthStart);
      to = formatDate(nextMonthEnd);
      break;
    }
    case "this_week": {
      const startOfThisWeek = new Date(today);
      startOfThisWeek.setDate(today.getDate() - today.getDay() + 1);
      from = formatDate(startOfThisWeek);
      const endOfThisWeek = new Date(startOfThisWeek);
      endOfThisWeek.setDate(startOfThisWeek.getDate() + 6);
      to = formatDate(endOfThisWeek);
      break;
    }
    case "next_week": {
      const startOfNextWeek = new Date(today);
      startOfNextWeek.setDate(today.getDate() + (7 - today.getDay()) + 1);
      from = formatDate(startOfNextWeek);
      const endOfNextWeek = new Date(startOfNextWeek);
      endOfNextWeek.setDate(startOfNextWeek.getDate() + 6);
      to = formatDate(endOfNextWeek);
      break;
    }
    case "this_month": {
      const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
      const thisMonthEnd = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        0
      );
      from = formatDate(thisMonthStart);
      to = formatDate(thisMonthEnd);
      break;
    }
    case "this_year": {
      const thisYearStart = new Date(today.getFullYear(), 0, 1);
      const thisYearEnd = new Date(today.getFullYear(), 11, 31);
      from = formatDate(thisYearStart);
      to = formatDate(thisYearEnd);
      break;
    }
    case "next_year": {
      const nextYearStart = new Date(today.getFullYear() + 1, 0, 1);
      const nextYearEnd = new Date(today.getFullYear() + 1, 11, 31);
      from = formatDate(nextYearStart);
      to = formatDate(nextYearEnd);
      break;
    }
    case "last_week": {
      const startOfLastWeek = new Date(today);
      startOfLastWeek.setDate(today.getDate() - today.getDay() - 6);
      from = formatDate(startOfLastWeek);
      const endOfLastWeek = new Date(startOfLastWeek);
      endOfLastWeek.setDate(startOfLastWeek.getDate() + 6);
      to = formatDate(endOfLastWeek);
      break;
    }
    case "all_time": {
      from = "1970-01-01";
      to = formatDate(today);
      break;
    }
    default:
      throw new Error(`Unknown date filter id: ${dateFilterId}`);
  }
  return { from, to };
};

const noPermissionMessage = "You don't have permission to create this form";

export const showNotification = (type, message) => {
  window?.casaHelperUtils?.showNotification(type, message);
};

export const openExternalLink = (url) => {
  window.open(url, "_blank");
};

export const checkPermission = async (item) => {
  const permissionEntityType =
    formEntites[item?.navigateTo?.id]?.PermissionEntityType;
  const entityId = item?.internalLink?.id;
  if (permissionEntityType === formEntites["Task/Form"].PermissionEntityType) {
    return true;
  }
  const isRestricted = await window?.casaHelperUtils?.getIsRestricted({
    permissionEntityType,
    actionType: "CREATE",
    entityId,
  });
  if (isRestricted) {
    showNotification(2, noPermissionMessage);
    return false;
  }
  return true;
};

export const handleFormNavigation = (item) => {
  const formConfig = {
    IsDefaultForm: true,
    FormId: null,
    Entity: formEntites[item?.navigateTo?.id]?.formEntity,
  };
  if (item.navigateTo.id === formEntites["Opportunity/Form"]?.name)
    formConfig.EntityType = item?.internalLink?.code?.toString();
  else if (item.navigateTo.id !== formEntites["Lead/Form"]?.name)
    formConfig.EntityType = item?.internalLink?.id;
  else {
    formConfig.EntityType = item?.internalLink?.internalName;
  }
  window?.casaHelperUtils?.showForms(formConfig);
};

export const handleDynamicFormNavigation = (item) => {
  const { FormId, ProcessAutoId, ActionId, ExecutionId } =
    item?.internalLink?.form?.process?.RelatedForms?.[0] || {};
  const formConfig = {
    FormId,
    ProcessAutoId,
    ActionId,
    ExecutionId,
  };
  window?.casaHelperUtils?.showForms(formConfig);
};

const handleNavigationRedirect = (item) => {
  const navigationLevels = ['navigationLevel4', 'navigationLevel3', 'navigationLevel2', 'internalLink'];
  
  for (const level of navigationLevels) {
    const navigationObj = item[level];
    if (navigationObj && navigationObj.path) {
      const redirectUrl = `${window.location.origin}${navigationObj.path}`;
      openExternalLink(redirectUrl);
      return;
    }
  }
};

export const onFormClick = async (item = {}) => {
  const { navigateTo, externalLink } = item;
  if (!navigateTo) return;
  if (navigateTo.id === "ExternalLink" && externalLink) {
    openExternalLink(externalLink);
    return;
  }
  if (navigateTo.type === "navigation") {
    handleNavigationRedirect(item);
    return;
  }
  if (Object.keys(formEntites).includes(navigateTo.id)) {
    const havePermission = await checkPermission(item);
    if (!havePermission) return;
    handleFormNavigation(item);
    return;
  }
  if (navigateTo.id === "Dynamic/Form") {
    handleDynamicFormNavigation(item);
  }
};

export const hasCookie = (name) => {
  return document.cookie
    .split(";")
    .some((cookie) => cookie.trim().startsWith(name + "="));
};

export const calculateProgress = (configData = {}) => {
  const { config = {} } = configData;
  const { count = 0, thresholds, maxCount, min = 0, max = 100 } = config;
  const clampedCount = Math.min(count, maxCount || max);
  const range = max - min || 1;
  let width = Math.max(1, Math.min(clampedCount - min, range));
  const widthPercentage = (width / range) * 100;

  if (!thresholds) {
    return {
      color: "rgb(var(--ng-neutral-70))",
      width: (clampedCount / (maxCount || max)) * 100 || 0,
    };
  }
  const { min: thresholdMin = 0, max: thresholdMax = 100 } = thresholds;
  return {
    color:
    count<=min?"rgb(var(--ng-neutral-70))":
      widthPercentage < thresholdMin
        ? "rgb(var(--ng-error-50))"
        : widthPercentage < thresholdMax
        ? "rgb(var(--ng-yellow-40))"
        : "rgb(var(--ng-green-40))",
    width: widthPercentage,
  };
};

export const isMiP = () => {
  return !!document?.getElementById("mip_pre_reqdata");
};

export const getPathPrefix = (entity) => {
  switch (entity) {
    case "Lead":
      return isMiP() ? "/LeadManagement" : "";
    case "Opportunity":
      return isMiP() ? "/OpportunityManagement" : "";
    case "Tasks":
      return "/Tasks/AllTasks"
    default:
      return "";
  }
};
